import React from 'react';
import { FormattedMessage } from 'react-intl';
// Redux
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IRootState } from '../../../redux';
// Store
import { loginUser } from '../../../redux/user/actions';
import { logoutUser } from '../../../redux/user/actions';
// Providers
import { getAccessToken, getUserInfo, getUserToken, getLogoutURL } from '../../../services/login.service';
// Components
import { AskCpr } from '../askcpr';
import { TokenDebug } from '../tokendebug/TokenDebug';
import { PopupButtons } from '../../../components/Popup/PopupButtons/PopupButtons';
import { Button, Popup, PopupContent } from '../../../components';
import IdleTimer from 'react-idle-timer';
// Config
import { staticConfig } from '../../../config/static';
// Helpers
import { getLoginState, getUser } from '../../../helpers/loginFlow';
import { loginRedirect, shouldSkipAuth } from '../../../helpers/auth';
// Enums
import { AuthRender, LoginFlowState } from '../../../enums';
import { IUserToken } from '../../../interfaces/login.interfaces';

import { FullScreenLoader } from '../../../components/Loader/FullScreenLoader';
import { clearAuthStorage } from '../../../helpers';

interface IAuthState {
    render: AuthRender;
    userToken: string;
    timerId?: ReturnType<typeof setTimeout>;
    popupShown: boolean;
    type: string;
}

class ClassicAuth extends React.Component<ReduxType, IAuthState> {
    constructor(props: ReduxType) {
        super(props);
        this.state = {
            render: AuthRender.Loading,
            userToken: null,
            type: null,
            timerId: null,
            popupShown: false,
        };
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const loginState = getLoginState(params, this.props);
        if (
            (this.props.isAuthorized || shouldSkipAuth()) &&
            loginState !== LoginFlowState.AskCpr &&
            loginState !== LoginFlowState.Logout &&
            loginState !== LoginFlowState.LoggedInCheckIfLoggedOutAction
        ) {
            const forcelogin = params.has('Login') && params.get('Login') === 'true';
            if (!forcelogin) {
                this.setState({ render: AuthRender.Loaded });
            }
        }

        const classicLogonPlace = localStorage.getItem('classicLogonPlace');
        let logoutUrl = staticConfig.classicLogoutEndpoint.replace('{domainType}', classicLogonPlace);
        switch (loginState) {
            case LoginFlowState.Logout:
                if (this.props.isAuthorized) {
                    clearAuthStorage();
                    const idptest = localStorage.getItem('idptest');
                    loginRedirect(idptest && idptest === '1');
                } else {
                    const redirectToLocation = localStorage.getItem('redirectToLocation');
                    logoutUrl += '?logout=done';
                    if (staticConfig.isclassicunavailable) {
                        logoutUrl = staticConfig.classicUnavailableLogoutEndpoint;
                    } else {
                        if (redirectToLocation) {
                            logoutUrl += '&redirectToLocation=' + redirectToLocation;
                        }
                    }
                    window.location.replace(logoutUrl);
                }

                //this.setState({ render: AuthRender.Loading });
                break;
            case LoginFlowState.Login:
                window.location.replace(logoutUrl);
                this.setState({ render: AuthRender.Loading });
                break;
            case LoginFlowState.LoggedInCheckIfLoggedOutAction:
                if (params.has('redirectToLocation')) {
                    localStorage.setItem('redirectToLocation', params.get('redirectToLocation'));
                }
                getUserInfo().then((res) => {
                    logoutUser();
                    clearAuthStorage();
                });

                //this.setState({ render: AuthRender.Loaded });
                break;
            case LoginFlowState.CompleteLoginFlow:
                if (this.props.isAuthorized) {
                    this.completeLoginFlow();
                } else {
                    getAccessToken(params.get('code')).then((res) => {
                        sessionStorage.removeItem('codeVerifier');
                        sessionStorage.removeItem('codeNonce');
                        sessionStorage.removeItem('codeState');

                        localStorage.removeItem('userWasCreated');
                        this.completeLoginFlow();
                    });
                }
                break;
            case LoginFlowState.UpdateAndGetUserToken:
                getUser(this.props).then(() => {
                    this.setState({ render: AuthRender.Loaded });
                });
                break;
            case LoginFlowState.AskCpr:
                this.setState({ render: AuthRender.AskCpr });
                break;
            case LoginFlowState.TokenDebug:
                if (staticConfig.temporaryTokenDebug) {
                    this.setState({ userToken: params.get('token') });
                    this.setState({ render: AuthRender.TokenDebug });
                } else {
                    const idptest = params.get('idptest');
                    loginRedirect(idptest && idptest === '1');
                }
                break;
            case LoginFlowState.ForceLogin:
                if (this.props.isAuthorized) {
                    if (params.has('idptest')) {
                        localStorage.setItem('idptest', params.get('idptest'));
                    }
                    getLogoutURL().then((response) => {
                        globalThis.location.href = response.url;
                    });
                } else {
                    const idptest = params.get('idptest');
                    loginRedirect(idptest && idptest === '1');
                }
                break;
            default:
                const idptest = params.get('idptest');
                loginRedirect(idptest && idptest === '1');
        }
    }

    componentWillUnmount() {
        this.stopTimer(this.state.timerId);
    }

    startTimer = (): ReturnType<typeof setTimeout> => {
        return setInterval(
            () => this.handleLogOff(),
            this.getTimeFromMinutesInMilliseconds(staticConfig.minutesBeforeAutoLogOffAfterAutoLogOffPopupShown)
        );
    };

    stopTimer = (timerId: ReturnType<typeof setTimeout>) => {
        clearInterval(timerId);
    };

    handleOnPopupOk = () => {
        this.stopTimer(this.state.timerId);
        this.setState({ popupShown: false });
    };

    getTimeFromMinutesInMilliseconds(minutes: number) {
        return minutes * 60 * 1000;
    }

    renderAskCpr = () => {
        if (!staticConfig.isclassicunavailable) {
            return <AskCpr cprLessUserToken={this.state.userToken} cprLessUserType={this.state.type} />;
        } else {
            this.setState({ render: AuthRender.Loaded });
            return true;
        }
    };

    private completeLoginFlow() {
        this.userTokenFlow(null);
        sessionStorage.removeItem('useTestIdp');

        localStorage.setItem('isAuthenticated', 'true');
    }

    private userTokenFlow = (cpr: string) => {
        const getTokenRequest = {
            cpr: cpr,
        };
        getUserToken(getTokenRequest).then((data: IUserToken) => {
            this.setState({ userToken: data.userToken });
            this.setState({ type: data.type });
            this.setState({ render: AuthRender.AskCpr });
            const classicLogonPlaceData = data.type === 'cvr' ? 'erhverv' : 'privat';
            window.localStorage.setItem('classicLogonPlace', classicLogonPlaceData);
        });
    };

    public render() {
        switch (this.state.render) {
            case AuthRender.Loaded:
                return (
                    <>
                        <IdleTimer
                            timeout={this.getTimeFromMinutesInMilliseconds(
                                staticConfig.inactiveMinutesBeforeAutoLogOffPopupShown
                            )}
                            onIdle={this.handleShowPopup}
                        >
                            {this.props.children}
                        </IdleTimer>

                        {this.state.popupShown ? (
                            <>
                                <Popup show headertext="AUTO_LOGOFF" type="alert">
                                    <PopupContent className="d-flex flex-column px-3 my-3">
                                        <FormattedMessage
                                            id="AUTO_LOGOFF_BODY"
                                            defaultMessage="AUTO_LOGOFF_BODY"
                                            values={{
                                                minutes: staticConfig.minutesBeforeAutoLogOffAfterAutoLogOffPopupShown,
                                            }}
                                        />
                                    </PopupContent>
                                    <PopupButtons className="pt-2">
                                        <Button type="button" onClick={this.handleOnPopupOk} className="mr-2">
                                            <FormattedMessage id="OK" />
                                        </Button>
                                    </PopupButtons>
                                </Popup>
                            </>
                        ) : null}
                    </>
                );
            case AuthRender.AskCpr:
                return this.renderAskCpr();
            case AuthRender.TokenDebug:
                return staticConfig.temporaryTokenDebug ? (
                    <TokenDebug token={this.state.userToken} />
                ) : (
                    this.props.children
                );
            case AuthRender.Loading:
            default:
                return <FullScreenLoader />;
        }
    }

    handleShowPopup = () => {
        this.setState({
            popupShown: true,
            timerId: this.startTimer(),
        });
    };

    handleLogOff = () => {
        this.stopTimer(this.state.timerId);
        this.props.logoutUser();
    };
}

const mapStateToProps = ({ user }: IRootState) => {
    return {
        isAuthorized: user.isAuthorized,
    };
};

const mapDispatcherToProps = (dispatch: Dispatch) => {
    return {
        loginUser: (userId: string) => dispatch(loginUser(userId)),
        logoutUser: () => dispatch(logoutUser()),
    };
};

type ReduxType = ReturnType<typeof mapDispatcherToProps> &
    ReturnType<typeof mapStateToProps> & { children?: React.ReactNode };

export default connect(mapStateToProps, mapDispatcherToProps)(ClassicAuth);
